module.exports = __webpack_public_path__ + "static/media/highlight.9496b9aa.png";